/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeterReadCreate } from '../models/MeterReadCreate';
import type { MeterReadDetails } from '../models/MeterReadDetails';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class ReadsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async readsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reads/get`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns MeterReadDetails OK
     * @throws ApiError
     */
    public static async readsVGetExport(
        requestBody?: PagingQuery,
    ): Promise<MeterReadDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reads/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any Accepted
     * @throws ApiError
     */
    public static async readsVCreate(
        requestBody?: MeterReadCreate,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/reads`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}